// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".response[data-v-f2074a08]{display:block;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;text-decoration:underline}", ""]);
// Exports
module.exports = exports;
